module.exports = __webpack_public_path__ + "419ce9c250395fc9639e49cce3670f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta/icon_catalog_dark.png
// module id = 729
// module chunks = 0 1